'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroBadgeSelect = require('./NitroBadgeSelect');

var _NitroBadgeSelect2 = _interopRequireDefault(_NitroBadgeSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroBadgeSelect2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-badge-select/index.js
// module id = 1284
// module chunks = 4